import TermModal from './TermModal';

export default TermModal;
